import 'vant/es/dialog/style';
import 'vant/es/toast/style';
import 'vant/es/cell/style';
import 'tdesign-mobile-vue/es/style/index.css';
import './style.css';

import { createApp } from 'vue';

import '@eaphone/polyfill';
import '@eaphone/style/style.scss';

import { VueQueryPlugin } from '@tanstack/vue-query';

import { loginHook } from '@eaphone/logic';
import { SentryInit } from '@eaphone/sentry';
import { store } from '@eaphone/store';

import pkg from '../package.json';

import App from './app.vue';
import { router } from './router/web.ts';

const app = createApp(App);

router.beforeEach(loginHook.bind(router));

SentryInit({
  app,
  router,
  version: pkg.version,
});

app.use(store).use(router).use(VueQueryPlugin);

app.mount('#root');
